const SidebarHR = () => <div className="h-1 mb-2 border-t border-zinc-800"></div>

export default SidebarHR;